import { type Asset, type ComponentLogoWithSpec } from '@lib/__generated/sdk'
import ContentfulImage from '@components/contentful/contentful-image'
import Zoom from 'react-medium-image-zoom'
import './custom-zoom-styles.css'
import Link from 'next/link'

interface ArticleAssetProps {
  image: Asset
}

interface ArticleImageProps {
  image: ComponentLogoWithSpec
}

export const ArticleImage = ({ image }: ArticleImageProps) =>
  image.image == null ? null : (
    <figure className='my-8 flex justify-center'>
      <div>
        <Zoom>
          <ContentfulImage
            className={
              image.embedFullWidth === true
                ? 'md:w-screen md:max-w-[calc(100vw-40px)] md:shrink-0'
                : 'rounded-md shadow-lg'
            }
            __typename='Asset'
            {...image.image}
            width={image.width ?? image.image.width ?? 0}
            height={image.height ?? image.image.height ?? 0}
          />
        </Zoom>
        {image.alt != null && (
          <figcaption className='mt-2 text-sm opacity-60'>
            {image.alt}
          </figcaption>
        )}
      </div>
    </figure>
  )

export const ArticleAsset = ({ image }: ArticleAssetProps) => {
  if (image == null || image.url == null) {
    return null
  }
  const contentfulImage = (
    <ContentfulImage
      className={'rounded-md shadow-lg'}
      {...(image as Required<Asset>)}
    />
  )
  const inner = image.description?.trim()?.startsWith('http') ? (
    <Link
      prefetch={false}
      href={new URL(image.description)}
      target='_blank'
      rel='noopener noreferrer'
    >
      {contentfulImage}
    </Link>
  ) : (
    <Zoom>{contentfulImage}</Zoom>
  )
  return (
    <figure className='my-8 flex justify-center'>
      <div>{inner}</div>
    </figure>
  )
}
